import { IconX } from '@tabler/icons-react'
import { ClearIndicatorProps, components } from 'react-select'

import { AstraIcon } from '../../../AstraIcon/AstraIcon'
import { SelectOption, SelectOptionGroup } from '../types'

export const clearIndicatorClassName = () => '!p-0 rounded-sm text-subtle hover:text-default transition-colors cursor-pointer'

export function CustomClearIndicator<T>(props: ClearIndicatorProps<SelectOption<T>, false, SelectOptionGroup<T>>) {
    return (
        <components.ClearIndicator {...props}>
            <AstraIcon icon={IconX} size="small" />
        </components.ClearIndicator>
    )
}
